import requestAction from '../../utils/requestAction'

interface CredentialsUpdate {
  oldPassword?: string
  newPassword: string
}

export const updateCredentials = (credentialsUpdate: CredentialsUpdate, cb = () => { }) => (search: string) =>
  requestAction('UPDATE_CREDENTIALS', search)('session/password', 'PUT', credentialsUpdate, undefined, undefined, cb)
